/**
 * Remembers which adjudicator has already been announced to the server on which
 * socket, so that the several places able to log a judge in do not each emit
 * their own copy.
 *
 * Deliberately module state, not a ref: the screens mount and unmount as the
 * user navigates, and a component-scoped record would forget on every
 * navigation. That is exactly how one login produced two - the Adjudicator
 * screen emits, then navigates to Home, whose mount effect emits again.
 *
 * Keyed by socket id as well as judge, so a genuine reconnect (new socket) is
 * always re-announced - server-side room membership does not survive it.
 */
let announced: string | null = null;

const keyFor = (socketId?: string, adjudicatorUuid?: string): string | null =>
  socketId && adjudicatorUuid ? `${socketId}:${adjudicatorUuid}` : null;

export function markLoginAnnounced(
  socketId?: string,
  adjudicatorUuid?: string
): void {
  const key = keyFor(socketId, adjudicatorUuid);
  if (key) announced = key;
}

export function isLoginAnnounced(
  socketId?: string,
  adjudicatorUuid?: string
): boolean {
  const key = keyFor(socketId, adjudicatorUuid);
  return key !== null && key === announced;
}

/** On log out, so the same judge signing back in is announced again. */
export function clearLoginAnnounced(): void {
  announced = null;
}
